<template>
  <AppModal
    :use-dimness="true"
    @close="$emit('close', false)"
  >
    <template #modal-body>
      <div
        v-if="isLoading"
        class="flex items-center justify-center"
      >
        <BaseSpinner />
      </div>
      <div v-else>
        <div
          v-if="!courses.length"
          class="opacity-50 text-center py-5"
        >No Courses Found For This {{ capitalize($localize('course set')) }}</div>
        <div
          v-else
          class="overflow-hidden rounded-lg m-3 border border-gray-200"
        >
          <table class="p-4 w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
              <tr>
                <th
                  scope="col"
                  class="py-3 px-6 bg-gray-50 dark:bg-gray-800"
                >
                  Name
                </th>
                <th
                  scope="col"
                  class="py-3 px-6"
                >
                  Code
                </th>
                <th
                  scope="col"
                  class="py-3 px-6 bg-gray-50 dark:bg-gray-800"
                >
                  Credits
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(course,i) in courses"
                :key="i"
                class="border-b border-gray-200 dark:border-gray-700"
              >
                <td
                  scope="row"
                  class="py-4 px-6 text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                >
                  <a
                    :href="course.url"
                    target="_blank"
                    class="text-blue-600 hover:opacity-80 transition-all duration-200"
                  >
                    {{ courseNameWithFallbacks(course) || '-' }}
                  </a>
                </td>
                <td class="py-4 px-6">
                  {{ course.code || '-' }}
                </td>
                <td class="py-4 px-6 bg-gray-50 dark:bg-gray-800">
                  {{ course.credits || '-' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </AppModal>
</template>

<script>
import { useContext, ref, onMounted } from '@nuxtjs/composition-api'
import AppModal from '@/components/AppModal'
import useDegreeMaps from '@/composables/useDegreeMaps'
import { courseNameWithFallbacks } from '@/utils/entityNames'
import { capitalize } from '@/utils/generalUtils'
export default {
  setup(props, { root }) {
    const { store, $axios, $localize } = useContext()
    const { getCourseRequirementTableObject } = useDegreeMaps(root, $localize)

    const school = store.state.settings.school
    const effectiveDatesRangeAsString =
      store.state.settings.effectiveDatesRangeAsString
    const courseSetId = props.value
    const isLoading = ref(true)
    const courses = ref([])
    async function fetchCoursesInCourseSet(courseSetId) {
      const data = await $axios.$get(
        `/cm/${school}/courseSets/${courseSetId}`,
        {
          params: {
            includeRelatedData: true,
            effectiveDatesRange: `${effectiveDatesRangeAsString}`,
            courseColumns: [
              'id',
              'code',
              'subjectCode',
              'courseNumber',
              'longName',
              'name',
              'credits',
            ],
          },
        }
      )
      isLoading.value = false
      return Object.values(data.courses) || []
    }

    onMounted(async () => {
      const data = await fetchCoursesInCourseSet(courseSetId)
      courses.value = data.map((course) =>
        getCourseRequirementTableObject(course.courseGroupId, data)
      )
    })

    return {
      isLoading,
      courses,
      courseNameWithFallbacks,
    }
  },
  components: { AppModal },
  methods: {
    capitalize,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
}
</script>
